import { InjectionToken } from '@angular/core';

import { Analytics } from 'firebase/analytics';

/**
 * Injection token used for injecting an instance of Firebase Analytics into dependent components or services.
 * This token allows for the retrieval or provisioning of a Firebase Analytics instance within an Angular application.
 */
export const FIREBASE_ANALYTICS_IT = new InjectionToken<Analytics>('analyticsInjectionToken');
